// extracted by mini-css-extract-plugin
export default {"chat_display":"chatDisplay_chat_display__Bof5+","sent":"chatDisplay_sent__h9SSH","received":"chatDisplay_received__PpIjT","chat_bubble":"chatDisplay_chat_bubble__VG8iG"};